import Vue from 'vue'
import Vuex from 'vuex'

import auth from "./auth.module";
import signboard from "./signboard.module";
import menu from "./menu.module";
import order from "./order.module";

Vue.use(Vuex)

const state = {
  prompt: false
}

const getters = {
  prompt() {
      return state.prompt
  }
}
const mutations = {
  
}
const actions = {
  promptToggle() {
      state.prompt = !state.prompt
  },
}

export default new Vuex.Store({
  state:state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  modules: {
    auth,
    signboard,
    menu,
    order,
  }
})